import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Add18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.75 8.25V1H8.25V8.25H1V9.75H8.25V17H9.75V9.75H17V8.25H9.75Z'
      fill='currentColor'
    />
  </Svg>
);

Add18.displayName = 'Add18';
export default Add18;
